jQuery(function($) {
	$(".timeline__slider").each(function () {

		new Swiper($(this).find(".swiper")[0], {
			slidesPerView: 'auto',
			speed: 600,
			freeMode: true,
			sticky: true,
			grabCursor: true,
			direction: 'vertical',
			spaceBetween: 40,
			navigation: {
				nextEl: $(this).find(".swiper-arrow.next")[0],
				prevEl: $(this).find(".swiper-arrow.prev")[0],
			},
			mousewheel: {
				releaseOnEdges: true,
				forceToAxis: true,
			},
		});
	});
});
